function handleFormKeyPress(event) {
  if (event.key === 'Enter' && event.target.type !== 'textarea') {
    event.preventDefault();
  }
}

export default handleFormKeyPress;
